import React, { useEffect } from "react"
import Layout from "../components/layout"
import parse from 'html-react-parser';
import { graphql, Link } from "gatsby"
import { scrollDiv, stripTags } from '../Helpers'
import Moment from 'moment';

import Seo from "../components/seo"

import Arrow from "../components/Arrow"
import BlogSingleHero from "../components/BlogSingleHero"
import LeadMagnet from "../components/LeadMagnet"
import BlockLastProjects from "../components/BlockLastProjects"

import IconEnvelope from "../components/icons/IconEnvelope"
import IconFacebook from "../components/icons/IconFacebook"
import IconLink from "../components/icons/IconLink"
import IconWhatsapp from "../components/icons/IconWhatsapp"

export default function SingleRatgeber({ data }) {
    const post = data.wpPost
    const acf = post.ratgeber

    let metaTitle = false
    let metaDescription = false
    let ogImage = false

    if (post.seoMetaData) {
        metaTitle = post.seoMetaData.seoMetaTitle ? post.seoMetaData.seoMetaTitle : false
        metaDescription = post.seoMetaData.seoMetaDescription ? post.seoMetaData.seoMetaDescription : false
        ogImage = post.seoMetaData.seoMetaOgImage ? post.seoMetaData.seoMetaOgImage : false
    }

    function toggleLinkConfirmation() {
        navigator.clipboard.writeText('https://www.rekord-fenster.com/ratgeber/' + post.slug)
        const confirm = document.getElementById('linkConfirmation')
        confirm.classList.toggle('hidden')
        setTimeout(function () {
            confirm.classList.toggle('hidden')
        }, 5000);
    }

    function scrollLeft() {
        document.getElementById('imageCarousel').scrollLeft -= 342;
    }
    function scrollRight() {
        document.getElementById('imageCarousel').scrollLeft += 342;
    }

    useEffect(function mount() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault()
                const yOffset = -200
                const element = document.getElementById(this.getAttribute('href').replace("#", ""))
                if (element) {
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
                    window.scrollTo({
                        top: y,
                        behavior: 'smooth'
                    })
                }
            })
        })

        var acc = document.getElementsByClassName("am-accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {

                this.classList.toggle("active");
                var panel = this.nextElementSibling;

                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }

            });
        }

    })

    var colors = {
        1: { "block": "bg-rekord-orange", "text": "text-white", "arrow": "#fff" },
        2: { "block": "bg-rekord-lorange", "text": "text-black", "arrow": "#000" },
        3: { "block": "bg-rekord-dorange", "text": "text-white", "arrow": "#fff" },
        4: { "block": "bg-rekord-lgreen", "text": "text-black", "arrow": "#000" },
        5: { "block": "bg-rekord-lgray", "text": "text-black", "arrow": "#000" }
    }

    if (acf.projAuthors) {
        var authorStructuredData = {
            '@type': 'Person',
            'name': acf.projAuthors[0].autoren.authorName
        }
    } else {
        var authorStructuredData = {
            '@type': 'Organization',
            'name': 'REKORD Fenster'
        }
    }

    var structuredData = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        'headline': stripTags(acf.projTitle),
        'author': authorStructuredData,
        'publisher': {
            '@type': 'Organization',
            'name': 'REKORD Fenster',
            'logo': {
                '@type': 'ImageObject',
                'url': 'https://rekord-fenster.b-cdn.net/wp-content/uploads/2023/03/REKORD_Logo_neuerClaim2021_png.webp'
            }
        },
        'datePublished': Moment(post.date).format('DD-MM-YYYY')
    }


    return (
        <Layout>
            <Seo
                metaTitle={metaTitle}
                metaDescription={metaDescription}
                uri={post.uri}
                ogImage={ogImage}
                type={'article'}
                modified={post.modifiedGmt}
            />
            <BlogSingleHero title={acf.projTitle} date={post.date} read={acf.projReadingTime} />
            <section className="container mx-auto lg:px-24 pb-24 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 blog-single-description">
                <div className="order-2 md:order-1">
                    {acf.projContents ? <h3 className="font-semibold text-lg mb-2">Inhalte der Seite</h3> : ''}
                    {acf.projContents && acf.projContents.map((cont, i) => (
                        <p key={i} className="mb-1 font-semibold"><a className="text-rekord-orange no-underline" href={cont.projContentsAnchor} rel="nofollow">{cont.projContentsText}</a></p>
                    ))}
                </div>
                {acf.projTextRight ? <div className="order-1 md:order-2">{parse(acf.projTextRight)}</div> : ''}
            </section>
            {acf.projAuthors ?
                <section className="container mx-auto px-4 lg:px-24 pb-12 md:pb-24 blog-single-authors">
                    {acf.projAuthorText ? <div className="block pb-6 font-light uppercase">{acf.projAuthorText}</div> : ''}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-12">
                        {acf.projAuthors.map((author, i) => (
                            <div key={i} className="flex items-center">
                                {author.autoren.authorImage ?
                                    <img className="w-32 h-32 object-cover rounded-full m-0" srcSet={author.autoren.authorImage.srcSet} alt={'Rekord Fenster | ' + author.autoren.authorName} sizes={author.autoren.authorImage.sizes} />
                                    : ''}
                                <div className="ml-4">
                                    <div className="text-xl font-semibold">{author.autoren.authorName}</div>
                                    <div className="text-lg font-light mb-4">{author.autoren.authorPosition}</div>
                                    <div className="text-base text-rekord-orange">{author.autoren.authorLocation}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
                : ''}
            <section className="blog-single-content">
                <div>
                    {post.content ? parse(post.content) : ''}
                </div>
            </section>
            {acf.projCarousel && acf.projCarousel !== '' ?
                <section className="bg-rekord-lgray">
                    <div className="container-carousel">
                        <div id="imageCarousel" className="overflow-x-auto overflow-y-hidden scroll-smooth whitespace-nowrap">
                            {acf.projCarousel.map((car, i, row) => (
                                <div key={i} className={i + 1 === row.length ? 'inline-block pb-8 ' : 'inline-block pb-8 pr-4 md:pr-8'}>
                                    <img className="w-full h-96 object-cover" srcSet={car.srcSet} alt={'Rekord Fenster | ' + car.altText} sizes={car.sizes} />
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-end pt-6">
                            <button onClick={() => { scrollLeft() }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32.621" height="24.543" viewBox="0 0 32.621 24.543">
                                    <g id="Pfeil" transform="translate(32.621)">
                                        <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H-29.378" transform="translate(0 11.771)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="3" />
                                        <path id="Fill_12" data-name="Fill 12" d="M-2.047,24.543,0,22.344-10.838,12.273,0,2.2-2.047,0l-13.2,12.273Z" transform="translate(-17.378)" />
                                    </g>
                                </svg>
                            </button>
                            <button className="ml-4" onClick={() => { scrollRight() }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32.621" height="24.543" viewBox="0 0 32.621 24.543">
                                    <g id="Pfeil" transform="translate(0)">
                                        <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H29.378" transform="translate(0 11.771)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="3" />
                                        <path id="Fill_12" data-name="Fill 12" d="M2.047,24.543,0,22.344,10.838,12.273,0,2.2,2.047,0l13.2,12.273Z" transform="translate(17.378)" />
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </section>
                : ''}
            {acf.projLeadMagnet && acf.projLeadMagnetUrl && acf.projLeadMagnetTitle && acf.projLeadMagnetText ?
                <LeadMagnet
                    formId={post.slug}
                    formUrl={acf.projLeadMagnetUrl}
                    title={acf.projLeadMagnetTitle}
                    text={acf.projLeadMagnetText}
                />
                : ''
            }
            <section className="container mx-auto lg:px-24 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 py-16 lg:py-24 blog-single-footer">
                <div>
                    {acf.projSources ? <h3 className="mb-6">Quellen</h3> : ''}
                    {acf.projSources && acf.projSources.map((source, i) => (
                        <p key={i}>
                            <a className="text-rekord-orange no-underline text-base" href={source.projSourcesUrl} target="_blank" rel="noreferrer">{source.projSourcesText ? source.projSourcesText : source.projSourcesUrl}</a>
                        </p>
                    ))}
                </div>
                <div>
                    <h3>Teilen</h3>
                    <div className="w-full grid grid-cols-5 md:grid-cols-8 gap-4 lg:gap-6 mt-6 mr-24">
                        <div className="aspect-square bg-rekord-lgray flex items-center justify-center shadow-lg">
                            <a role="button" aria-label="Jetzt per Email teilen" href={'mailto:office@rekord-fenster.com?subject=Schau diese Seite! &amp;body=Hi there, Check out this site: https://www.rekord-fenster.com/ratgeber/' + post.slug} rel="nofollow"><IconEnvelope w="30" h="30" /></a>
                        </div>
                        <div className="aspect-square bg-rekord-lgray flex items-center justify-center shadow-lg">
                            <a role="button" aria-label="Jetzt auf Facebook teilen" href={'https://www.facebook.com/sharer/sharer.php?u=https://www.rekord-fenster.com/ratgeber/' + post.slug} target="_blank" rel="noreferrer nofollow"><IconFacebook w="30" h="30" /></a>
                        </div>
                        <div className="aspect-square bg-rekord-lgray flex items-center justify-center shadow-lg relative">
                            <div id="linkConfirmation" className="hidden -top-12 text-center w-52 absolute bg-rekord-lgray px-2 py-1 shadow-lg text-xs bg-green-200 border border-green-700 text-green-700">Link erfolgreich in die Zwischenablage kopiert!</div>
                            <button aria-label="Mute volume" onClick={() => { toggleLinkConfirmation() }}><IconLink w="30" h="30" /></button>
                        </div>
                        <div className="aspect-square bg-rekord-lgray flex items-center justify-center shadow-lg">
                            <a role="button" aria-label="Jetzt per WhatsApp teilen" href={'whatsapp://send?text=Schau diese Seite: https://www.rekord-fenster.com/ratgeber/' + post.slug} data-action="share/whatsapp/share" target="_blank" rel="noreferrer nofollow"><IconWhatsapp w="30" h="30" /></a>
                        </div>
                    </div>
                </div>
            </section>
            {acf.projMostRequested ?
                <section className="bg-white block-products-categories">
                    <div className="container mx-auto py-16 lg:py-24">
                        <h3 className="uppercase block mb-12 text-lg font-normal">Ratgeber</h3>
                        <div className="flex flex-col md:flex-row gap-6 md:gap-0 justify-between items-end md:items-center">
                            <span className="font-bold text-2xl lg:text-4xl pl-6 lg:px-24 pb-12">
                                Die meistgesuchten <span className="text-rekord-green">Fragen</span> zur <br />
                                Fenster-Welt
                            </span>
                            <div>
                                <Link to="/ratgeber" className="btn btn-green" title="Rekord Fenster | Ratgeber">
                                    alle Artikel
                                </Link>
                            </div>
                        </div>
                        <div className="relative">
                            <div id="projectsList" className="overflow-x-auto overflow-y-hidden scroll-smooth whitespace-nowrap">
                                {acf.projMostRequested.map((proj, i, row) => {
                                    return (
                                        <article key={i} className={i + 1 === row.length ? 'h-full inline-flex flex-col mb-8 w-full md:w-1/2 lg:w-1/4 whitespace-normal' : 'h-full inline-flex flex-col mb-8 mr-4 w-full md:w-1/2 lg:w-1/4 whitespace-normal'}>
                                            <Link to={'/ratgeber/' + proj.slug} title={'Rekord Fenster | ' + proj.title}>
                                                {proj.ratgeber.projCover ?
                                                    <div className="block h-72 w-full">
                                                        <img className="w-full h-full object-cover" srcSet={proj.ratgeber.projCover.srcSet} alt={proj.ratgeber.projCover.altText} sizes="(max-width: 384px) 100vw, 384px" />
                                                    </div>
                                                    : ''}
                                            </Link>
                                            <div className={colors[(i + 1)].block + ' p-6 h-60 flex flex-col justify-end'}>
                                                <Link className="no-underline" to={'/ratgeber/' + proj.slug} title={'Rekord Fenster | ' + proj.title}>
                                                    <h1 className={colors[(i + 1)].text + ' block mt-4 mb-2 text-2xl font-light no-underline'}>{proj.title}</h1>
                                                    <Arrow color={colors[(i + 1)].arrow} />
                                                </Link>
                                            </div>
                                        </article>
                                    )
                                })}
                            </div>
                            <div className="flex justify-end pt-6">
                                <button onClick={() => { scrollDiv('projectsList', 'left', acf.projMostRequested.length) }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32.621" height="24.543" viewBox="0 0 32.621 24.543">
                                        <g id="Pfeil" transform="translate(32.621)">
                                            <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H-29.378" transform="translate(0 11.771)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="3" />
                                            <path id="Fill_12" data-name="Fill 12" d="M-2.047,24.543,0,22.344-10.838,12.273,0,2.2-2.047,0l-13.2,12.273Z" transform="translate(-17.378)" />
                                        </g>
                                    </svg>
                                </button>
                                <button className="ml-2" onClick={() => { scrollDiv('projectsList', 'right', acf.projMostRequested.length) }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32.621" height="24.543" viewBox="0 0 32.621 24.543">
                                        <g id="Pfeil" transform="translate(0)">
                                            <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H29.378" transform="translate(0 11.771)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="3" />
                                            <path id="Fill_12" data-name="Fill 12" d="M2.047,24.543,0,22.344,10.838,12.273,0,2.2,2.047,0l13.2,12.273Z" transform="translate(17.378)" />
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
                : <BlockLastProjects />
            }
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
            />
        </Layout>
    )
}
export const query = graphql`
  query($slug: String!) {
    wpPost(slug: {eq: $slug}) {
         slug
         uri
         title
         content
         excerpt
         date
         modifiedGmt(formatString: "YYYY-MM-DDTHH:mm:ss")
         seoMetaData {
            seoMetaTitle
            seoMetaDescription
            seoMetaOgImage {
              height
              width
              sourceUrl
              mimeType
            }
         }
         categories {
             nodes {
                 slug
             }
         }
         ratgeber {
             projLeadMagnet
             projLeadMagnetUrl
             projLeadMagnetTitle
             projLeadMagnetText
             projAuthorText
             projMostRequested {
                ... on WpPost {
                  databaseId
                  slug
                  title
                  ratgeber {
                    projCover {
                       altText
                       srcSet
                       uri
                       sizes
                   	}
                  }
                }
              }
             projTitle
             projTextRight
             projReadingTime
             projCover {
                 srcSet
                 uri
                 sizes
                 altText
                 height
                 width
                 sourceUrl
                 mimeType
             }
             projContents {
                 projContentsAnchor
                 projContentsText
             }
             projSources {
                 projSourcesText
                 projSourcesUrl
             }
             projCarousel {
                 altText
                 srcSet
                 uri
                 sizes
             }
             projAuthors {
                 ... on WpAutor {
                     autoren {
                         authorImage {
                             srcSet
                             uri
                             sizes
                         }
                         authorName
                         authorLocation
                         authorPosition
                     }
                 }
             }
         }
     }
  }
`
